var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shareInfoStatus)?_c('div',{staticClass:"poster-first"},[_c('div',{staticClass:"mask-share"},[_c('img',{attrs:{"src":require("@assets/images/share-info.png")},on:{"click":_vm.shareInfoClose}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }